const options = {
    speed: 5000,
    loop: true,
    autoplay: {
        delay: -1,
        disableOnInteraction: false,
    },
    slidesPerView: 1,
    breakpoints: {
        1200: {
            slidesPerView: 2,
        },
        1600: {
            slidesPerView: 3,
        },
    },
};

class NewsTicker {
    constructor(elements) {
        this.elements = elements;
    }

    init() {
        this.elements.forEach((element) => {
            const Slider = slider.default;
            this.newsTicker = new Slider(element, options);
        });
    }
}

const newsTicker = {
    init() {
        const elements = document.querySelectorAll('.js-news-ticker');

        if (!elements.length) return;

        this.ticker = new NewsTicker(elements);
        this.ticker.init();
    },
};

export default newsTicker;
